// extracted by mini-css-extract-plugin
module.exports = {"printable":"RxDrugCard_printable__nh81O"};